import { type FunctionComponent, type PropsWithChildren, createContext, useState } from 'react';
import { DEFAULT_TAB } from '../../helpers/jump-tabs/jump-tabs.helpers';
import { type JumpTabNavButton } from '../../types/jump-tabs.types';
import { scrollToElement } from '../../utils/dom/dom.utils';

type JumpTabsContextState = {
	tabs: JumpTabNavButton[];
	selectedTab: JumpTabNavButton;
	setSelectedTab: (selectedTab: JumpTabNavButton, scroll: boolean) => void;
};

const initialState: JumpTabsContextState = {
	tabs: [],
	selectedTab: DEFAULT_TAB,
	setSelectedTab: () => {}
};

export const JumpTabsContext = createContext<JumpTabsContextState>(initialState);

type JumpTabsProviderProps = {
	tabs: JumpTabNavButton[];
};

export const JumpTabsProvider: FunctionComponent<PropsWithChildren<JumpTabsProviderProps>> = ({ children, tabs }) => {
	const [selectedTab, setSelectedTab] = useState(DEFAULT_TAB);

	const onSetTab = (tab: JumpTabNavButton, scroll = true) => {
		setSelectedTab(tab);
		const anchor = tab.anchor;
		if (scroll) {
			scrollToElement(anchor, 75);
		}
	};

	const value = { selectedTab, setSelectedTab: onSetTab, tabs };

	return <JumpTabsContext.Provider value={value}>{children}</JumpTabsContext.Provider>;
};
